<template>
  <section
    :style="data.style ? data.style :  isDark ? 'secondary' : ''"
    :class="`${isDark ? 'secondary white--text' : ''}`"
  >
    <v-container>
      <v-divider :dark="isDark" :class="data.class" :style="data.style"></v-divider>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "PageDivider",
  props: ["value"],
  data() {
    return {};
  },
  computed: {
    data() {
      return this.value;
    },
    isDark() {
      return this.value.dark ? true : false;
    }
  }
};
</script>

<style>
</style>